/* Kornerprint — correctifs : ajout au panier avec fichiers + reprise de la personnalisation 3D dans le devis */
(function () {
  'use strict';
  var MAX = 19.5 * 1048576; /* limite Shopify ~20 Mo par envoi */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function mo(b) { return (b / 1048576).toFixed(1).replace('.', ',') + ' Mo'; }
  function toast(msg, long) {
    var t = $('[data-kp-toast]'); if (!t) { if (long) alert(msg); return; }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, long ? 7000 : 2600);
  }
  function openCart() {
    var b = document.createElement('button'); b.type = 'button'; b.hidden = true; b.setAttribute('data-kp-open', 'kp-cart');
    document.body.appendChild(b); b.click(); b.remove();
  }

  /* ---------- 1. Ajout au panier : toujours en AJAX, fichiers compris ---------- */
  function addToCart(form, btn) {
    var fd = new FormData(form), clean = new FormData(), files = [], total = 0, dropped = [];
    fd.forEach(function (v, k) {
      if ((typeof v === 'string' && v.trim() === '') || (v instanceof File && !v.size)) return;
      if (v instanceof File) { files.push([k, v]); return; }
      clean.append(k, v);
    });
    files.sort(function (a, b) { return a[1].size - b[1].size; }).forEach(function (kv) {
      if (total + kv[1].size > MAX) { dropped.push(kv); clean.append(kv[0], 'Fichier « ' + kv[1].name + ' » trop lourd (' + mo(kv[1].size) + ') : à envoyer par e-mail à adv@auffan.com'); return; }
      total += kv[1].size; clean.append(kv[0], kv[1]);
    });
    var label = btn ? (btn.getAttribute('data-label') || btn.textContent.trim()) : '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; btn.textContent = total > 400000 ? 'Envoi de votre fichier…' : 'Ajout en cours…'; }
    var routes = (window.KP && window.KP.routes) || {};
    return fetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: clean, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 413) throw { description: 'Fichier trop lourd (20 Mo maximum). Réessayez avec un fichier plus léger ou envoyez-le à adv@auffan.com.' };
        return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function () {
        openCart();
        if (dropped.length) toast('Ajouté au panier ✓ — votre fichier dépasse 20 Mo : envoyez-le à adv@auffan.com', true);
        else toast('Ajouté au panier ✓');
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Erreur, veuillez réessayer', true); })
      .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.textContent = label || 'Ajouter au panier'; } });
  }
  /* capture : passe avant le gestionnaire historique (qui envoyait le formulaire en rechargement de page dès qu'un fichier était joint) */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-kp-ajax-add]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[type=submit]');
    if (btn && btn.classList.contains('is-loading')) return;
    addToCart(form, btn);
  }, true);

  /* avertissement fichier trop lourd dès le dépôt du logo */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || i.type !== 'file' || i.name !== 'properties[Logo]') return;
    var f = i.files && i.files[0];
    if (f && f.size > MAX) toast('Votre fichier pèse ' + mo(f.size) + ' : au-delà de 20 Mo il ne pourra pas être joint à la commande. Envoyez-le ensuite à adv@auffan.com.', true);
  }, true);

  /* ---------- 2. Personnalisation 3D : image 3D + placement, et reprise dans le devis ---------- */
  function productInfo(root) {
    var form = $('form[data-kp-ajax-add]', root), info = { title: '', variant: '', url: location.pathname, handle: location.pathname.split('/').pop() };
    var h1 = $('h1', root); info.title = h1 ? h1.textContent.trim() : document.title;
    try {
      var id = form && form.querySelector('[name=id]') ? form.querySelector('[name=id]').value : '';
      var js = $('script[data-kp-product-json]', root), pj = js ? JSON.parse(js.textContent) : null;
      var v = pj && (pj.variants || []).filter(function (x) { return String(x.id) === String(id); })[0];
      if (v) info.variant = v.public_title || v.title || '';
      if (pj && pj.title) info.title = pj.title;
    } catch (e) {}
    return info;
  }
  function loadImg(src) { return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  function save(q) {
    try { sessionStorage.setItem('kpQuote', JSON.stringify(q)); }
    catch (e) { try { var q2 = Object.assign({}, q); delete q2.img; sessionStorage.setItem('kpQuote', JSON.stringify(q2)); } catch (e2) {} }
  }
  function buildProof(root) {
    var proofIn = $('[data-studio-proof]', root), main = $('.kp-gallery__main.is-3d img', root) || $('[data-studio-done] img', root);
    var propIn = $('[data-studio-prop]', root), facesIn = $('[data-studio-faces-prop]', root);
    var logoIn = $('input[type=file][name="properties[Logo]"]', root);
    var info = productInfo(root);
    var shotSrc = main && /^data:image/.test(main.src) ? main.src : null;
    var planche = proofIn && proofIn.files && proofIn.files[0];
    var p = [shotSrc ? loadImg(shotSrc).catch(function () { return null; }) : Promise.resolve(null),
             planche ? loadImg(URL.createObjectURL(planche)).catch(function () { return null; }) : Promise.resolve(null)];
    return Promise.all(p).then(function (imgs) {
      var shot = imgs[0], pl = imgs[1], W = 1200, pad = 24;
      if (!shot && !pl) return null;
      var sh = 0, sw = 0; if (shot) { sw = W - 2 * pad; sh = Math.round(sw * shot.naturalHeight / shot.naturalWidth); if (sh > 900) { sh = 900; sw = Math.round(sh * shot.naturalWidth / shot.naturalHeight); } }
      var ph = pl ? Math.round(W * pl.naturalHeight / pl.naturalWidth) : 0;
      var c = document.createElement('canvas'); c.width = W; c.height = 80 + sh + (pl ? ph + 10 : 20);
      var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height);
      x.fillStyle = '#1d1d1f'; x.font = '600 26px system-ui, Arial'; x.fillText('Kornerprint · aperçu 3D (non contractuel)', pad, 40);
      x.font = '15px system-ui, Arial'; x.fillStyle = '#555'; x.fillText((info.title + (info.variant ? ' — ' + info.variant : '')).slice(0, 120), pad, 64);
      if (shot) x.drawImage(shot, Math.round((W - sw) / 2), 80, sw, sh);
      if (pl) x.drawImage(pl, 0, 80 + sh + 10, W, ph);
      if (c.height > 4000) { var k = 4000 / c.height, c2 = document.createElement('canvas'); c2.width = Math.round(W * k); c2.height = 4000; c2.getContext('2d').drawImage(c, 0, 0, c2.width, c2.height); c = c2; }
      return new Promise(function (res) {
        c.toBlob(function (blob) {
          if (blob && proofIn) {
            try { var dt = new DataTransfer(); dt.items.add(new File([blob], 'apercu-3d-placement.jpg', { type: 'image/jpeg' })); proofIn.files = dt.files; proofIn.disabled = false; } catch (e) {}
          }
          var qw = Math.min(1000, c.width), qc = document.createElement('canvas'); qc.width = qw; qc.height = Math.round(c.height * qw / c.width);
          qc.getContext('2d').drawImage(c, 0, 0, qc.width, qc.height);
          var lf = logoIn && logoIn.files && logoIn.files[0];
          var q = { t: Date.now(), title: info.title, variant: info.variant, url: info.url, handle: info.handle,
            faces: facesIn ? facesIn.value : '', placement: propIn ? propIn.value : '', logo: lf ? lf.name : '', img: qc.toDataURL('image/jpeg', .82) };
          root._kpQuote = q; save(q); res(q);
        }, 'image/jpeg', .88);
      });
    });
  }
  function initProduct() {
    var root = $('[data-kp-product]'); if (!root) return;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-studio-validate]')) return;
      setTimeout(function () { buildProof(root); }, 700); /* après l'enregistrement du studio (planche générée en asynchrone) */
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="demande-de-devis"]'); if (!a || !root.contains(a)) return;
      var info = productInfo(root), q = root._kpQuote ? Object.assign({}, root._kpQuote) : { url: info.url, handle: info.handle };
      q.t = Date.now(); q.title = info.title; q.variant = info.variant;
      save(q);
    }, true);
  }

  /* ---------- 3. Formulaire de devis : texte prérempli + aperçu 3D joint ---------- */
  function initQuote() {
    var raw = null; try { raw = sessionStorage.getItem('kpQuote'); } catch (e) {}
    if (!raw) return;
    var q; try { q = JSON.parse(raw); } catch (e) { return; }
    if (!q || Date.now() - (q.t || 0) > 2 * 86400000) return;
    var tries = 0;
    (function wait() {
      var form = $('form[action*="powerfulform"]') || $('.globo-formbuilder form');
      var ta = form && form.querySelector('textarea');
      if (!form || !ta) { if (++tries < 80) setTimeout(wait, 250); return; }
      if (form._kpq) return; form._kpq = 1;
      var txt = ['Demande de devis pour : ' + q.title + (q.variant ? ' (' + q.variant + ')' : '')];
      if (q.faces) txt.push('Faces imprimées : ' + q.faces);
      if (q.placement) txt.push('Placement du logo : ' + q.placement);
      if (q.logo) txt.push('Fichier logo : ' + q.logo + ' (je vous le transmets en réponse si besoin)');
      if (q.url) txt.push('Produit : ' + location.origin + q.url);
      if (!ta.value.trim()) {
        ta.value = txt.join('\n') + '\n\n';
        ta.dispatchEvent(new Event('input', { bubbles: true })); ta.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var attached = false;
      if (q.img) {
        var fin = form.querySelector('input[type=file][id^="temp-for-"]') || form.querySelector('input[type=file]');
        try {
          var bin = atob(q.img.split(',')[1]), u = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
          var dt = new DataTransfer(); dt.items.add(new File([u], 'apercu-3d-' + (q.handle || 'produit') + '.jpg', { type: 'image/jpeg' }));
          if (fin) { fin.files = dt.files; fin.dispatchEvent(new Event('change', { bubbles: true })); attached = true; }
        } catch (e) {}
      }
      var note = document.createElement('div');
      note.style.cssText = 'display:flex;gap:14px;align-items:center;background:#f3f8e8;border:1px solid #cfe3a6;border-radius:14px;padding:12px 14px;margin:0 0 18px;font-size:14px;line-height:1.4';
      note.innerHTML = (q.img ? '<img src="' + q.img + '" alt="" style="width:72px;height:72px;object-fit:cover;object-position:top;border-radius:10px;background:#fff;flex:none">' : '') +
        '<div><strong>' + (attached ? '✓ Votre aperçu 3D est joint à votre demande' : '✓ Votre produit est repris dans votre demande') + '</strong><br><span style="opacity:.75">' +
        String(q.title || '').replace(/[<>&]/g, '') + ' — complétez vos coordonnées puis envoyez.</span></div>';
      var host = form.closest('.globo-formbuilder') || form;
      host.parentNode.insertBefore(note, host);
      form.addEventListener('submit', function () { try { sessionStorage.removeItem('kpQuote'); } catch (e) {} });
    })();
  }

  function start() { initProduct(); initQuote(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
